import React, { Component, Fragment } from 'react';

class Table extends Component {
    generateTableData = () => {
        const { data } = this.props;

        if (!data.edges || data.edges.length < 1) {
            return (
                <tr>
                    <td colSpan={3} style={{ textAlign: 'center' }}>No Rate Data</td>
                </tr>
            )
        }

        let list = data.edges.map((edge, index) => {
            if (edge.node.details.data.length === 1) {
                return (
                    <tr key={index}>
                        <td rowSpan={1}>{edge.node.gacha_name}</td>
                        <td>{edge.node.details.data[0].content}</td>
                        <td>{edge.node.details.data[0].rate}</td>
                    </tr>
                )
            }
            else {
                return (
                    <Fragment key={index}>
                        <tr>
                            <td rowSpan={edge.node.details.data.length}>{edge.node.gacha_name}</td>
                            <td>{edge.node.details.data[0].content}</td>
                            <td>{edge.node.details.data[0].rate}</td>
                        </tr>
                        {this.generateOtherRow(edge.node.details.data)}
                    </Fragment>
                )
            }
        })

        return list;
    }

    generateOtherRow = (data) => {
        let list = [];

        for (let index = 1; index < data.length; index++) {
            list.push(
                <tr key={index}>
                    <td>{data[index].content}</td>
                    <td>{data[index].rate}</td>
                </tr>
            )
        }

        return list;
    }

    render() {
        return (
            <table>
                <thead>
                    <tr>
                        <th>Gacha Name</th>
                        <th>Content</th>
                        <th>Rate</th>
                    </tr>
                </thead>
                <tbody>
                    {this.generateTableData()}
                </tbody>
            </table>
        );
    }
}

export default Table;